import { useState } from 'preact/hooks';
import { Field, fieldId } from './Field';

export function Toggle({ label, hint, checked, onChange }: { label: string; hint?: string; checked: boolean; onChange: (v: boolean) => void }) {
  const [id] = useState(() => fieldId('toggle'));
  return (
    <Field label={label} hint={hint} htmlFor={id}>
      <button id={id} type="button" role="switch" aria-checked={checked} class={`toggle${checked ? ' on' : ''}`} onClick={() => onChange(!checked)}>
        <span class="toggle-track">
          <span class="toggle-thumb" />
        </span>
        <span class="toggle-text">{checked ? 'On' : 'Off'}</span>
      </button>
    </Field>
  );
}
